module.exports = __webpack_public_path__ + "img/outlines.202967b1.gif";